/*
 * ar-collab-models.js
 * sections/ar-collab-models.liquid の「もっと見る」アコーディオン動作。
 * SP は initial_mobile 件、PC は initial_pc 件まで初期表示し、超過分は折りたたむ。
 */
(function () {
  function init(root) {
    if (root.dataset.arCmInit === 'true') return;
    root.dataset.arCmInit = 'true';

    const items = root.querySelectorAll('[data-ar-cm-item]');
    const toggle = root.querySelector('[data-ar-cm-toggle]');
    if (!items.length || !toggle) return;

    const initialMobile = parseInt(root.dataset.initialMobile, 10) || 6;
    const initialPc = parseInt(root.dataset.initialPc, 10) || 8;
    let expanded = false;
    const mq = window.matchMedia('(min-width: 750px)');

    function applyState() {
      const initial = mq.matches ? initialPc : initialMobile;
      let hiddenCount = 0;
      items.forEach(function (item, i) {
        const shouldHide = !expanded && i >= initial;
        item.classList.toggle('is-hidden', shouldHide);
        if (shouldHide) hiddenCount++;
      });
      const showToggle = items.length > initial;
      toggle.hidden = !showToggle;
      const text = toggle.querySelector('.ar-cm__more-text');
      const icon = toggle.querySelector('.ar-cm__more-icon');
      if (expanded) {
        if (text) text.textContent = '閉じる';
        if (icon) icon.textContent = '▲';
      } else {
        if (text) text.textContent = 'もっと見る';
        if (icon) icon.textContent = '▼';
      }
    }

    toggle.addEventListener('click', function () {
      expanded = !expanded;
      applyState();
    });

    if (mq.addEventListener) {
      mq.addEventListener('change', applyState);
    } else if (mq.addListener) {
      mq.addListener(applyState);
    }
    applyState();
  }

  function initAll() {
    document.querySelectorAll('[data-ar-cm]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-ar-cm]');
    if (root) {
      root.dataset.arCmInit = 'false';
      init(root);
    }
  });
})();
